import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { gtmSend } from '../../helpers';
// import history from '../../other/history';
import { notificationsFetch } from '../../actions/index';
import { Icon } from '../../components/Common/Icon';
// import Loader from '../../components/Common/Loader';
import { ProfileThumb } from '../../components/Common/CardComponents';
import { NotificationLinksPlaceholder } from '../../components/Common/ContentPlaceholder';
import cx from '../../styles';
// import style from './style.css';

class NotificationContainer extends Component {

    constructor(props) {
        super(props);
        this.state = { showLinks: false, eof: false, isLoading: false };
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escHandler, false);
        document.addEventListener('mousedown', this.outsideClickHandler);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escHandler, false);
        document.addEventListener('mousedown', this.outsideClickHandler);
    }

    onFetchNotifications = () => {
        if (!this.state.showLinks) {
            gtmSend('view notifications', 'notification', 'click', 'view');
            gtmSend('cw_notification_check', 'Notification', 'Check Notifications', '--', 0);
            this.setState({ showLinks: true, isLoading: true });
            this.props.notificationsFetch(0)
            .then(() => {
                this.setState({isLoading: false});
            })
        } else {
            this.setState({ showLinks: false });
        }
    }

    onLoadMoreClick = () => {
        // exit if end reached
        if(this.state.eof) return false;
        this.setState({isLoading: true});
        //add elems
        let nextLength;
        const prevLength = this.props.appReducer.notifications.length;
        //fetch next        
        this.props.notificationsFetch(prevLength ? this.props.appReducer.notifications[prevLength - 1].id : 0, false)
        .then(() => {
            this.setState({isLoading: false});
            nextLength = this.props.appReducer.notifications.length;
            if(prevLength == nextLength) this.setState({eof: true});
        });
    }

    onNotificationClick = (slug) => {
        this.closePopout();
        //history.push causing url with double replyId 
        //history.push({
            //pathname: slug
        //});
        window.location.href = slug;
    }

    closePopout = () => {
        this.setState({ showLinks: false });
    }

    escHandler = (event) => {
        if (event.keyCode === 27) {
            this.closePopout();
        }
    }

    outsideClickHandler = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.closePopout();
        }
    }

    actionLinks = () => {
        const {t, appReducer} = this.props;

        return (
            <div className={cx("notification-list")} id={'notification-list'}>
                <div className={cx("notification-head")}>
                    <span className={cx("only-mobile", "close-modal")} onClick={this.closePopout} >
                        <Icon name="cross-regular-dark-smd" />
                    </span>

                    <div>{t('notification_title')}</div>
                </div>
                <div className={cx("notification-body")}>
                    <ul>
                        {
                            appReducer.notifications.map((notification, i) => {
                                return (
                                    <li key={i} className={cx(notification.is_read && "is-read")}>
                                        <a href={notification.slug} onClick={(e) => { e.preventDefault(); this.onNotificationClick(notification.slug); gtmSend('cw_notifications_open', 'Notifications', 'Open Notifications', `${notification.target_id}`, 0, {postType: `${notification.target}`})}}>
                                            <div className={cx("notification-img-wrap")}>
                                                <ProfileThumb img={notification.image_big ? notification.image_big : ""} altName={`${notification.title} icon`} />
                                                <span style={{ backgroundImage: `url(${notification.image})` }} />
                                            </div>
                                            <div className={cx("notification-title-warp")}>
                                                <div>
                                                    <p>{notification.title}</p>
                                                    <span>{notification.nice_time}</span>
                                                </div>
                                                <p>{notification.text}</p>
                                            </div>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    {
                        this.state.isLoading &&
                        <NotificationLinksPlaceholder />
                    }
                    {
                        !this.state.eof && appReducer.notifications.length !== 0 &&
                        <div className={cx('load-more-btn')} onClick={this.onLoadMoreClick}>Load More</div>
                    }
                </div>
            </div>
        );
    }

    render() {
        const {appReducer} = this.props;

        return (
            <div className={"notification-container"}>
                <div className={cx("action-link")} ref={node => this.wrapperRef = node}>
                    <span className={cx("notification-wrap")} onClick={this.onFetchNotifications}>
                        <Icon name='notification-regular' />
                        {
                            appReducer.notificationCount > 0 &&
                            <span className={cx("notification-count")}>{appReducer.notificationCount}</span>
                        }
                    </span>
                    <div className={cx("tooltip-card", (this.state.showLinks ? "active" : ""))} >{this.actionLinks()}</div>
                </div>
                {/*appReducer.isLoading && <Loader />*/}
            </div>
        );
    }
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        notificationsFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(NotificationContainer));
